export enum PortalUsersFilterOption {
  Username,
  Name,
}
